import { wrapper } from 'src/redux/store'
import { getRemoteMapData } from 'src/redux/thunks'
import { ENTITY } from 'src/consts'
import GlobalCharts from 'src/pages/GlobalCharts'

const Charts = props => <GlobalCharts {...props} />

export const getStaticProps = wrapper.getStaticProps(store => async () => {
  await store.dispatch(
    getRemoteMapData({
      entity: ENTITY.COIN,
      url: process.env.NEXT_PUBLIC_API_ENDPOINT,
    })
  )

  return {
    revalidate: 10 * 60,
  }
})

export default Charts
